<template>
    <div class="info-pax">
        <b-container>

            <h2 v-if="title" class="info-pax--text" v-html="title"></h2>

            <div v-if="icons" class="info-pax--icons">
                <div class="info-pax--icons--block">
                    <div class="info-pax--icon" v-html="loading"></div>
                    <div class="info-pax--text">
                        <strong class="title">
                            Richiedi la pubblicazione
                        </strong>
                        <p class="info-pax--info">
                            Compila il form qui sotto
                        </p>
                    </div>
                </div>
                <div class="info-pax--icons--block arrow">
                    <div v-html="arrow"></div>
                </div>
                <div class="info-pax--icons--block">
                    <div class="info-pax--icon" v-html="cart"></div>
                    <div class="info-pax--text">
                        <strong class="title">
                            Prenota il viaggio
                        </strong>
                        <p class="info-pax--info">
                            Riceverai un'email con le istruzioni su come fare non appena il viaggio sarà online
                        </p>
                    </div>
                </div>
            </div>
            <div class="info-pax--text" v-html="text_top"></div>

            <div v-if="text_middle" class="info-pax--text success" v-html="text_middle">

            </div>

            <div v-if="adults.length">
                <b-form-group id="info-pax--adults" :state="form_validate()">
                    <b-row v-for="(adult,index) in adults" v-bind:key="index">
                        <b-col sm="12" v-if="index==0">
                            <div class="info-pax--block">
                                <div v-html="user"></div>
                                <div class="info-pax--block--title">
                                    Viaggiatore principale
                                    <div v-html="info" v-b-popover.hover.right="'A norma di legge, il viaggiatore principale può essere solamente il titolare del credito welfare o un suo familiare'"></div>
                                </div>
                            </div>
                        </b-col>
                        <b-col sm="12" v-if="index==1">
                            <div class="info-pax--block pt-2">
                                <div v-html="user"></div>
                                <div>Altri viaggiatori</div>
                            </div>
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Nome</label>
                            <b-form-input
                                :ref="'info-pax--adults-firstname-'+index"
                                :id="'info-pax--adults-firstname-'+index"
                                :class="field_validate(adults[index].firstname) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Nome"
                                v-model="adults[index].firstname"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Cognome</label>
                            <b-form-input
                                :ref="'info-pax--adults-lastname-'+index"
                                :id="'info-pax--adults-lastname-'+index"
                                :class="field_validate(adults[index].lastname) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Cognome"
                                v-model="adults[index].lastname"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Data di nascita</label>
                            <b-form-input
                                :ref="'info-pax--adults-birth-'+index"
                                :id="'info-pax--adults-birth-'+index"
                                :class="field_validate(adults[index].birth) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Data di nascita"
                                v-model="adults[index].birth"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                    </b-row>
                </b-form-group>
            </div>

            <div v-if="children.length">
                <b-form-group id="info-pax--children" :state="form_validate()">
                    <b-row v-for="(child,index) in children" v-bind:key="index">
                        <b-col sm="12" v-if="index==0 && adults.length == 1">
                            <div class="info-pax--block pt-2">
                                <div v-html="user"></div>
                                <div>Altri viaggiatori</div>
                            </div>
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Nome</label>
                            <b-form-input
                                :ref="'info-pax--children-firstname-'+index"
                                :id="'info-pax--children-firstname-'+index"
                                :class="field_validate(children[index].firstname) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Nome"
                                v-model="children[index].firstname"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Cognome</label>
                            <b-form-input
                                :ref="'info-pax--children-lastname-'+index"
                                :id="'info-pax--children-lastname-'+index"
                                :class="field_validate(children[index].lastname) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Cognome"
                                v-model="children[index].lastname"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                        <b-col sm="12" md="4">
                            <label>Data di nascita</label>
                            <b-form-input
                                :ref="'info-pax--children-birth-'+index"
                                :id="'info-pax--children-birth-'+index"
                                :class="field_validate(children[index].birth) ? 'valid' : 'non-valid'"
                                type="text"
                                placeholder="Data di nascita"
                                v-model="children[index].birth"
                            ></b-form-input>
                            <!--<div class="formerror"></div>-->
                        </b-col>
                    </b-row>
                </b-form-group>
            </div>

            <b-row>
                <b-col>
                    <div class="checkbox">
                        <b-form-checkbox v-model="checkbox_1" ref="checkbox-checkbox_1" required type="checkbox" name="checkbox" id="checkbox-checkbox_1" />
                        <label for="checkbox-checkbox_1" class="checkbox-label">
                            In qualità di Beneficiario della prestazione (Viaggiatore principale) dichiaro di aver letto e di accettare l'informativa privacy fornendo il consento al trattamento dei dati personali comunicati.
                        </label>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <div class="checkbox">
                        <b-form-checkbox v-model="checkbox_2" ref="checkbox-checkbox_2" required type="checkbox" name="checkbox" id="checkbox-checkbox_2" />
                        <label for="checkbox-checkbox_2" class="checkbox-label">
                            Consapevole che, ai sensi dell'art. 76 del DPR 445/2000, le dichiarazioni mendaci, la falsità e l'uso di fatti falsi sono punite ai sensi del Codice penale e delle leggi speciali vigenti in materia, dichiaro di aver indicato - quale Beneficiario della prestazione (Viaggiatore principale) - un familiare* conformemente a quanto previsto dal combinato disposto dell'Art. 433 del Codice Civile e dell'Art. 12 del D.P.R. del 22.12.1986 n. 917 e smi (TUIR).
                        </label>
                    </div>
                </b-col>
            </b-row>

            <div class="info-pax--text" v-html="text_down"></div>
            <div>
                <button-with-icon
                    variant="cta"
                    :text="text_cta"
                    :disabled="!form_validate()"
                    :clicked="() => {
                        $emit('completed', {
                            pax_adults: this.adults,
                            pax_children: this.children,
                        })
                    }"
                />
            </div>

            <div class="info-pax--text" >
              <span><small>*un familiare conformemente a quanto previsto dal combinato disposto dell'Art. 433 del Codice Civile e dell'Art. 12 del D.P.R del 22.12.1986 n. 917 e smi (TUIR): il coniuge, anche dello stesso sesso (unione civile), i genitori e, in loro mancanza, gli ascendenti prossimi; gli adottanti, i figli legittimi e/o illegittimi e/o naturali e/o adottivi; in loro mancanza, i discendenti prossimi, anche naturali, i generi e le nuore; il suocero e la suocera; i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</small></span>
            </div>
        </b-container>
    </div>
</template>

<script>
    import Bwi from '@/components/atoms/button-with-icon'
    import { user, info, loading, cart, arrow } from '@/components/svg/common'
    export default {
        name: 'info-pax',
        components: {
            'button-with-icon': Bwi,
        },
        props:{
            occupancy: {
                type: Object,
                default: () => {
                    return {
                        adults: 1,
                    }
                }
            },
            title:
            {
              type: String,
              default: '',
            },
            icons:
            {
              type: Boolean,
              default: false,
            },
            text_top:
            {
                type: String,
                default: '',
            },
            text_middle:
            {
              type: String,
              default: '',
            },
            text_down:
            {
                type: String,
                default: '',
            },
            all_pax: {
                type: Boolean,
                default: true,
            },
            text_cta:{
              type: String,
              default: 'Conferma e prosegui',
            }
        },
        data() {
            return {
                adults: [],
                children: [],
                checkbox_1: false,
                checkbox_2: false,
            }
        },
        created()
        {
            this.user = user
            this.info = info
            this.loading = loading
            this.cart = cart
            this.arrow = arrow
        },
        methods:
        {
            field_validate(value)
            {
                return (value !== '')
            },
            form_validate()
            {
                if(!this.checkbox_1) return false
                if(!this.checkbox_2) return false

                let pax = (this.adults).concat(this.children)
                
                let check = true

                pax.forEach(p => {
                    if(!this.field_validate(p.firstname)) check = false
                    if(!this.field_validate(p.lastname)) check = false
                    if(!this.field_validate(p.birth)) check = false
                })

                return check
            }
        },
        mounted()
        {
            // c'è un volo => chiedo info per tutti i viaggiatori previsti da quote.details.occupancy
            if(this.all_pax)
            {
                if(this.occupancy.adults)
                {
                    for (let a=0; a<this.occupancy.adults; a++ )
                    {
                        this.adults.push({
                            firstname: '',
                            lastname: '',
                            birth: '',
                        })
                    }
                }
                if(this.occupancy.children)
                {
                    this.occupancy.children.forEach(() => {
                        this.children.push({
                            firstname: '',
                            lastname: '',
                            birth: '',
                        })  
                    })
                }
            }
            
            // NON c'è un volo => chiedo info solo per il viaggiatore principale
            else
            {
                this.adults.push({
                    firstname: '',
                    lastname: '',
                    birth: '',
                })
            }

            this.form_validate()
        }
    }
</script>

<style lang="scss">
    .info-pax
    {
        font-size: 14px;
        &--text
        {
            text-align:center;
            font-weight: bold;
            margin:$grid-gutter-width/2 0;
        }
        &--block
        {
            display: flex;
            align-items: center;
            //margin-top:$grid-gutter-width/4;
            margin-bottom:0.5rem;
            font-weight: bold;
            color:$primary;
            &--title
            {
                display: flex;
                align-items: center;
                svg
                {
                    margin-left:0.5rem;
                }
            }
            svg
            {
                margin-right:0.75rem;
            }
        }
        .form-control
        {
            margin-bottom:0.5rem;
            &.valid
            {
                border-color:$success;
            }
            &.non-valid
            {
                //border-color:$danger;
            }
        }

        .checkbox
        {
            display:flex;
            font-size: 11px;
            margin-top:$grid-gutter-width/2;
        }

        .bwi
        {
            max-width: 400px;
            margin:0 auto;
            margin-top:2rem;
        }

        svg
        {
            path
            {
                fill:$primary;
            }
        }
        &--icons
        {
            display:flex;
            flex-wrap: wrap;
            justify-content: center;
            &--block
            {
                padding:0 20px;
                height: inherit;
            }
        }

        &--icon
        {
            width:80px;
            height:auto;
            text-align: center;
            margin:0 auto;
            margin-top:40px;
            svg
            {
                max-width: 100%;
                height:auto;
            }
        }
        &--info
        {
            font-weight: normal;
            max-width: 180px;
            margin:0 auto;
        }
        .success
        {
            color:$success;
            font-size: 18px;
            margin-bottom:60px;
        }
        .title
        {
            min-height:60px;
            display: block;
            max-width: 140px;
            margin:0 auto;
        }

        .arrow
        {
            display:flex;
            align-items: flex-start;
            padding-top:50px;
            svg
            {
                width:40px;
                height:auto;
                path
                {
                    fill:#666;
                }
            }
        }
    }

    #info-pax-modal
    {
        .modal-header
        {
            background:$tertiary;
            border:0;
        }
        .modal-title,
        .close
        {
            color:$white;
        }
    }
</style>